import rab1 from '../img/rabbits/Cyber-Hacker.webp'
import rab2 from '../img/rabbits/Hip-Hop.webp'
import rab3 from '../img/rabbits/Punk.webp'
import rab4 from '../img/rabbits/Hertzl.webp'
import rab5 from '../img/rabbits/Mad-Max.webp'
export const rabImages = [
    rab1, rab2, rab3, rab4, rab5
]